export const redirect = [
  // {
  //   from: '^(?!^\\/$|^\\/[?].*$)(.*\\/\\/(www\\.)[^?]*[?\\/].*|(.*\\/$))',
  //   to: (from: any, req: any) => {
  //     const base = req._parsedUrl.pathname.replace(/\/$/, '');
  //     const { search } = req._parsedUrl;
  //     const host = req?.headers?.host.replace('www.', '') || '';
  //
  //     return host + base + (search != null ? search : '');
  //   },
  // },

  {
    // eslint-disable-next-line
    from: '(?!^\\/$|^\\/[?].*$)(.*\\/[?](.*)$|.*\\/$)',
    to: (from: any, req: any) => {
      const base = req._parsedUrl.pathname.replace(/\/$/, '');
      const { search } = req._parsedUrl;
      return base + (search != null ? search : '');
    },
  },
];
